import { useState } from 'react';
import { Navigate, Link, useNavigate } from 'react-router-dom';
import { useUser } from '../providers/UserProvider';
import { PASSWORD_MIN_LENGTH } from '../auth';
import { AuthLayout } from '../components/AuthLayout';
import * as authRepository from '../repositories/authRepository';

export default function SignupPage() {
  const { isLoggedIn, login } = useUser();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  if (isLoggedIn) return <Navigate to="/tldr" replace />;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');
    const form = new FormData(e.currentTarget);
    const password = String(form.get('password') || '');
    const confirmPassword = String(form.get('confirmPassword') || '');
    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }
    try {
      const data = await authRepository.signup(
        form.get('username') as string,
        form.get('email') as string,
        password,
      );
      login(data);
      navigate('/tldr', { replace: true });
    } catch (err) {
      setMessage((err as Error).message || 'Signup failed');
    }
  };

  return (
    <AuthLayout
      title="Create Account"
      subtitle="Start with a private account and a gated reader."
      message={message}
      isError={!!message}
      footer={<Link to="/login">Back to sign in</Link>}
    >
      <form onSubmit={handleSubmit} className="auth-form">
        <label>
          <span>Username</span>
          <input type="text" name="username" autoComplete="username" required />
        </label>
        <label>
          <span>Email</span>
          <input type="email" name="email" autoComplete="email" required />
        </label>
        <label>
          <span>Password</span>
          <input type="password" name="password" autoComplete="new-password" minLength={PASSWORD_MIN_LENGTH} required />
        </label>
        <label>
          <span>Confirm password</span>
          <input type="password" name="confirmPassword" autoComplete="new-password" minLength={PASSWORD_MIN_LENGTH} required />
        </label>
        <button type="submit" className="primary-button">Create account</button>
      </form>
    </AuthLayout>
  );
}
